import { Component, Vue } from 'vue-property-decorator'
import { validPassword } from '../../../helper-functions/validators'
import textInput from '../../../components/text-input/text-input.vue'

@Component({
  components: {
    textInput
  }
})

export default class ResetPassword extends Vue {
  
  private namespace: string = '/Account';
  
  private token: string = '';

  private username: string = '';

  private password: string = '';

  private passwordMatch: string = '';

  private alertMessage: string = '';
 
  private submitted: boolean = false;

  private error: boolean = false;

  private disabled: boolean = false;

  private get ValidPassword (): boolean {
    
    return validPassword(this.password, this.username);
  }

  private get ConfirmedPassword (): boolean {

    return this.password != '' && this.password === this.passwordMatch
  }

  private get enabled () {
    
    return this.password != null
      && this.ValidPassword
       && this.ConfirmedPassword
        && !this.disabled;
  }

  created () {
    
    if (this.$route.query.username && this.$route.query.token) {
      
      this.token = this.$route.query.token as string;
      this.username = this.$route.query.username as string
      return;
    }

    this.$router.replace({name: 'login'});
  }

  private alertReset () {

    setTimeout(() => {   

      if (this.error) {

        this.error = !this.error;
      }

      this.alertMessage = '';
    }, 5000);
  }

  private async setNewPassword () {

    this.submitted = true;

    try {

      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/ResetPassword`, {
        Username: this.username,
        Password: this.password,
        Token: this.token
      });
      
      this.submitted = false;
      this.alertMessage = this.$t('account.reset.msg') as string;
      this.$router.replace({name: 'login'});

    } catch (err) {

      this.submitted = false;
      this.error = !this.error;
      this.alertMessage = this.$t('errors.general') as string;
      this.alertReset();
    }
  }
}